import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, Grid, Typography, withWidth, withStyles } from '@material-ui/core';
import calculateSpacing from './calculateSpacing';
// import BenefitsSection from './BenefitSection';
// import BigMoneySection from './BigMoneySection';

const styles = (theme) => ({
  cardWrapper: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: 345,
    color: theme.palette.common.white,
  },
  gridContainer: {
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  wrapper: {
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
    paddingTop: 20,
    paddingBottom: 180,
    textAlign: 'center',
    color: theme.palette.common.white,
  },
});

const items = [
  {
    title: 'QC and File Transformation Services',
    items: [
      'Audio and video linear QC with optional auto enhancements (Baton, Vidchecker)',
      'Audit QC and asset interrogation (technical Master QC)',
      'File ingest optimization',
      'Custom intake verification',
      'File manipulation and conform services',
    ],
  },
  {
    title: 'Digital Packaging',
    items: [
      'White-label digital packaging solution',
      'Complete, turnkey, backend servicing',
      'Incoming and outgoing asset verification ensures frictionless delivery',
      'Deliver to over 100 platforms',
      'Deliver on-time and FAST!',
    ],
  },
];

const renderItem = (item) => {
  return (
    <Box textAlign='left'>
      <Typography>
        <Box display='flex' alignItems='center'>
          <img src={`${process.env.PUBLIC_URL}/images/nx-logo.svg`} alt='logo' height={50} /> {item.title}
        </Box>
      </Typography>
      <ul>
        {item.items.map((text, index) => (
          <li key={`list-item-${index}`}>{text}</li>
        ))}
      </ul>
    </Box>
  );
};

function MainSection({ width, classes }) {
  return (
    <div className={classes.wrapper}>
      <div className={classNames('container-fluid')}>
        <Typography variant='h3' style={{ marginBottom: 30 }}>
          Critical services, on demand.
        </Typography>
        <Grid container spacing={calculateSpacing(width)} className={classes.gridContainer}>
          {items.map((item, index) => (
            <Grid key={`cta-${index}`} item sm={12} md={4} className={classes.cardWrapper}>
              {renderItem(item)}
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

MainSection.propTypes = {
  width: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(withWidth()(MainSection));
